import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {};

const getters = {};

const actions = {
  index({ commit }, params) {
    return Service.RSPExtend.index(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  show({ commit }, params) {
    return Service.RSPExtend.show(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  create({ commit }, params) {
    return Service.RSPExtend.create(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  createPendingGroup({ commit }, params) {
    return Service.RSPExtend.createPendingGroup(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  store({ commit }, data) {
    return Service.RSPExtend.store(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  edit({ commit }, data) {
    return Service.RSPExtend.edit(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  update({ commit }, data) {
    return Service.RSPExtend.update(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  delete({ commit }, data) {
    return Service.RSPExtend.delete(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
